import { ReactNode } from 'react';
import { RadioList } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

import { IPostCreateUser } from '@/features/user/contexts/CreateUserContext';

interface IBooleanRadio {
  value?: string;
  label?: string;
  customLabel?: ReactNode;
  name: keyof IPostCreateUser;
  handleRadioChange: (value: string, key: keyof IPostCreateUser) => void;
  direction?: 'column' | 'row';
  testId: string;
}

export function BooleanRadio({
  name,
  value,
  label,
  customLabel,
  handleRadioChange,
  direction = 'row',
  testId,
  ...rest
}: IBooleanRadio) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      {customLabel}
      <RadioList
        label={label}
        options={[
          { label: t('translation:components.molecules.forms.yes'), value: '1', testId: `${testId}-yes` },
          { label: t('translation:components.molecules.forms.no'), value: '0', testId: `${testId}-no` },
        ]}
        value={value}
        onChange={(value: string) => handleRadioChange(value, name)}
        direction={direction}
        {...rest}
      />
    </div>
  );
}
